import { render, staticRenderFns } from "./PopupSendOtp.vue?vue&type=template&id=1ee791d8&scoped=true"
import script from "./PopupSendOtp.vue?vue&type=script&lang=js"
export * from "./PopupSendOtp.vue?vue&type=script&lang=js"
import style0 from "./PopupSendOtp.vue?vue&type=style&index=0&id=1ee791d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee791d8",
  null
  
)

export default component.exports